/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function Finance() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('');

    const handleAddFinanceClick = () => {
        navigate('/addfinance');
    };

    useEffect(() => {
        const fetchRegistrationData = async () => {
            try {
                const response = await axiosInstance.get('/dealer/listforfinance');
            } catch (error) {
                console.error('Error fetching registration data:', error);
            }
        };

        fetchRegistrationData();
    }, []);

    // Create a reusable fetchData function
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('/finance/');
            setData(response.data);
            console.log("data:", response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    function formatDate(dateStr) {
        if (!dateStr) return ''; // Return empty string if dateStr is undefined or empty

        const date = new Date(dateStr); // Convert date string to Date object

        return date.toLocaleDateString('en-GB', {
            day: 'numeric',    // 10
            month: 'numeric',    // Mar
            year: 'numeric'    // 2024
        });
    }

    const handleView = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to View this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, View it!',
        });

        if (result.isConfirmed) {
            navigate('/viewfinance', { state: { row } });
        }
    };

    const handleEdit = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });

        if (result.isConfirmed) {
            navigate('/addfinance', { state: { row } });
        }
    };

    const handleReceipt = async (row) => {

        // Check if vehicle is still seized
        if (row.issizzed == 1 || row.issizzed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Create Receipt!',
                text: 'Please release the vehicle first then create Receipt.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Check if vehicle is still seized
        if (row.isclosed == 1 || row.isclosed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Create Receipt!',
                text: 'This Finance is closed already',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to create receipt?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, create it!',
        });

        if (result.isConfirmed) {
            navigate('/addreceipt', { state: row });
        }
    };

    const handlefull = async (row) => {

        // Check if vehicle is still seized
        if (row.issizzed == 1 || row.issizzed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Make Settlement!',
                text: 'Please release the vehicle first then create Receipt.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Check if vehicle is still seized
        if (row.isclosed == 1 || row.isclosed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Make Settlement!',
                text: 'This Finance is closed already',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want make full settlement?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, make it!',
        });
        if (result.isConfirmed) {
            navigate('/fullsettlement', { state: { row } });
        }
    };

    // Add this function to handle releasing seized vehicle
    const handleRelease = async (row) => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: 'Release Seized Vehicle?',
                text: `Are you sure you want to release the seized vehicle ${row.reg_no}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, release it!',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {
                // Make PUT request to update isseized status
                const response = await axiosInstance.put(`/finance/${row.id}`, {
                    issizzed: 0,
                    modified_by: localStorage.getItem('user_id')
                });

                // Make PUT request to update isseized status
                const sizzedresponse = await axiosInstance.delete(`/seizedvehicle/finance/${row.id}`, {
                    data: {
                        modified_by: localStorage.getItem('user_id')
                    }
                });

                // Show success message
                Swal.fire({
                    title: 'Released!',
                    text: 'The seized vehicle has been released successfully.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

                // Refresh the data to reflect changes
                fetchData(); // Replace with your data fetching function name
            }
        } catch (err) {
            console.error('Release error:', err);
            Swal.fire({
                title: 'Error!',
                text: err.response?.data?.message || 'Failed to release the seized vehicle',
                icon: 'error'
            });
        }
    };


    const handleDelete = useCallback(async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            // Optimistic UI update: Set 'inactive' to 0 immediately
            const updatedData = data.filter(item => item.id !== id);
            setData(updatedData); // Update the state immediately

            try {
                // Make a PUT request to update the 'inactive' field to 0
                await axiosInstance.delete(`/finance/${id}`);

                Swal.fire('Deleted!', 'The Finance record has been deleted successfully.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue in deleting finance record.', 'error');

                // Revert the state if the request fails
                setData(prevData => [...prevData, data.find(item => item.id === id)]);
            }
        }
    }, [data]);


    const filteredData = data.filter(item =>
        (String(item.reg_no || '').toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.borrower_name || '').toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.date || '').toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.loan_amount || '').toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.emi_amount || '').toLowerCase().includes(searchText.toLowerCase()))
    );


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.reg_no,
            sortable: true,
            width: '180PX',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Date</span>,
            selector: row => new Date(row.date).toLocaleDateString("en-GB"),
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>HP No</span>,
            selector: row => row.hp_number || '',
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Borrower Name</span>,
            selector: row => row.borrower_name,
            sortable: true,
            width: '200px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Loan Amount</span>,
            selector: row => row.loan_amount,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>EMI Amount</span>,
            selector: row => row.emi_amount,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Status</span>,
            cell: row => {
                if (row.issizzed === 1 || row.issizzed === true) {
                    return (
                        <small className="badge badge-danger">
                            <i className="fa fa-motorcycle"></i> Seized
                        </small>
                    );
                } else if (row.isclosed === 1 || row.isclosed === true) {
                    return (
                        <small className="badge badge-danger">
                            <i className="fa fa-lock"></i> Closed
                        </small>
                    );
                } else {
                    return (
                        <small className="badge badge-success">
                            <i className="fa fa-check-circle"></i> Active
                        </small>
                    );
                }
            },
            sortable: false,
            width: '80px',
            style: {
                fontWeight: '800',
                textAlign: 'center'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    {/* Conditional Release button - only show when isseized is 1 */}
                    {row.issizzed == 1 && (
                        <button
                            onClick={() => handleRelease(row)}
                            className="btn btn-info btn-sm"
                            style={{ marginRight: '8px' }}
                            title="Release Seized Vehicle"
                        >
                            <i className="fa fa-motorcycle"></i>
                        </button>
                    )}
                    <button onClick={() => handleView(row)} className="btn btn-warning btn-sm" style={{ marginRight: '8px' }} title="View Finance"><i className="fa fa-eye"></i></button>
                    <button onClick={() => handleReceipt(row)} className="btn btn-success btn-sm" style={{ marginRight: '8px' }} title="Add Receipt"><i className="fa fa-receipt"></i></button>
                    <button onClick={() => handlefull(row)} className="btn btn-danger btn-sm" style={{ marginRight: '8px' }} title="Full Settlement"><i className="fa fa-random"></i></button>
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }} title="Edit Finance"><i className="fa fa-edit"></i></button>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger btn-sm" title="Delete Finance"><i className="fa fa-trash"></i></button>
                </div>
            ),
            width: '250px'
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Finance</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Finance</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col d-flex justify-content-end">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={handleAddFinanceClick}
                    >
                        <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
                        Add Finance
                    </button>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="form-control mb-3"
                            />
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={100}  // Set number of rows per page
                                paginationRowsPerPageOptions={[100, 200, 300, 400]}
                            />
                        </div>
                    </div>
                </div >
            </div >

        </div >
    )
}
export default Finance